import React, { useEffect, useContext } from 'react';

import SiteSeeContext from './SiteSeeContext';

const SiteSeeNavigationGuide = () => {
  const { siteSeeName, actionWord, siteSeeGuideMode } = useContext(SiteSeeContext);
  const isCoached = siteSeeGuideMode === 'tour';
  const mapShell = document?.querySelector('.mapShell') ? document.querySelector('.mapShell') : null;
  const mapShellClassList = mapShell ? mapShell.classList : null;

  useEffect(() => {
    if (!mapShell) return;
    if (isCoached) {
      mapShellClassList.add('mapShell--spotlight');
    } else {
      mapShellClassList.remove('mapShell--spotlight');
    }
    return () => {
      mapShellClassList.remove('mapShell--spotlight');
    };
  }, [isCoached, mapShell]);

  return (
    <>
      { actionWord }
      , hold and drag anywhere on the
      {' '}
      {siteSeeName}
      {' '}
      to move around the community.
    </>
  );
};

export default SiteSeeNavigationGuide;
